// extracted by mini-css-extract-plugin
module.exports = {"divider":"PayrollReport_divider__hCn1L","title":"PayrollReport_title__1-EQm","spacer":"PayrollReport_spacer__3-OZq","rightBtnCol":"PayrollReport_rightBtnCol__neK1M"};